import { couponConstants } from '../constants';
import { couponService } from '../../services';

export const couponActions = {
  couponsList,
  addCoupon,
  getCoupon,
  updateCoupon
}

/*
ACTION: Coupons List
*/
function couponsList(addToast, pageID, perPage) {
  return dispatch => {
    dispatch(request());
    return couponService.couponsList(pageID, perPage)
      .then(
        response => {
          dispatch(success(response.data.body.coupons, response.data.body.total));
        },
        error => {
          if(typeof error === 'object') {
            Object.keys(error).map(key => {
              addToast(error[key], { appearance: 'error', autoDismiss: true });
            })
          } else {
            addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
          }
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: couponConstants.GETALL_REQUEST } }
  function success(items, total) { return { type: couponConstants.GETALL_SUCCESS, items, total } }
  function failure(error) { return { type: couponConstants.GETALL_FAILURE, error } }
}

/*
ACTION: Add Coupon
*/
function addCoupon(addToast, formData) {
  return dispatch => {
    dispatch(request());
    return couponService.addCoupon(formData)
      .then(
        response => {
          addToast('عملیات با موفقیت انجام شد.', { appearance: "success", autoDismiss: true });
          dispatch(success(true));
        },
        error => {
          if(typeof error === 'object') {
            Object.keys(error).map(key => {
              addToast(error[key], { appearance: 'error', autoDismiss: true });
            })
          } else {
            addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
          }
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: couponConstants.ADD_REQUEST } }
  function success(status) { return { type: couponConstants.ADD_SUCCESS, status } }
  function failure(error) { return { type: couponConstants.ADD_FAILURE, error } }
}

/*
ACTION: Get Coupon By ID
*/
function getCoupon(addToast, couponID) {
  return dispatch => {
    dispatch(request());
    return couponService.getCoupon(couponID)
      .then(
        response => {
          dispatch(success(response.data.body));
        },
        error => {
          if(typeof error === 'object') {
            Object.keys(error).map(key => {
              addToast(error[key], { appearance: 'error', autoDismiss: true });
            })
          } else {
            addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
          }
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: couponConstants.GET_REQUEST } }
  function success(item) { return { type: couponConstants.GET_SUCCESS, item } }
  function failure(error) { return { type: couponConstants.GET_FAILURE, error } }
}

/*
ACTION: Update Coupon
*/
function updateCoupon(addToast, formData) {
  return dispatch => {
    dispatch(request());
    return couponService.updateCoupon(formData)
      .then(
        response => {
          addToast('بروزرسانی با موفقیت انجام شد.', { appearance: "success", autoDismiss: true });
          dispatch(success(true));
        },
        error => {
          if(typeof error === 'object') {
            Object.keys(error).map(key => {
              addToast(error[key], { appearance: 'error', autoDismiss: true });
            })
          } else {
            addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
          }
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: couponConstants.UPDATE_REQUEST } }
  function success(status) { return { type: couponConstants.UPDATE_SUCCESS, status } }
  function failure(error) { return { type: couponConstants.UPDATE_FAILURE, error } }
}